import { render, staticRenderFns } from "./moduleView.vue?vue&type=template&id=43cd9b5a&scoped=true"
import script from "./moduleView.vue?vue&type=script&lang=js"
export * from "./moduleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cd9b5a",
  null
  
)

export default component.exports